var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7549 13.4983C10.6142 14.3251 9.21467 14.812 7.70225 14.812C3.86533 14.812 0.754883 11.678 0.754883 7.81201C0.754883 3.94602 3.86533 0.812012 7.70225 0.812012C9.21467 0.812012 10.6142 1.29895 11.7549 2.12572C12.8955 1.29895 14.2951 0.812012 15.8075 0.812012C19.6444 0.812012 22.7549 3.94602 22.7549 7.81201C22.7549 11.678 19.6444 14.812 15.8075 14.812C14.2951 14.812 12.8955 14.3251 11.7549 13.4983Z",
    fill: "url(#paint0_radial_4855_9917)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4855_9917",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.06662 16.7224 -26.278 -3.78817 17.8797 9.05516)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29142,
    stopColor: "#C5D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82B5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudLogo);
export default __webpack_public_path__ + "static/media/cloudLogo.31c39898b4859ee3c934d178308cc828.svg";
export { ForwardRef as ReactComponent };